<template>
	<div class="finance container-fluid py-2">
		<div class="row">
			<div class="col-md-12 p-0 m-0">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>FINANCE REPORT</strong></span>
					</div>
					<div>
						<div class="mb-3" style="margin-top:-21px;">   
							<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<FinanceReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>	
			</div>
		</div>
	</div>
</template>

<script>

import FinanceReport from '@/components/page/FinanceReport.js'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportParamSearch from '@/views/pages/ReportParamSearch.vue'
import ReportParamDateRange from '@/views/pages/ReportParamDateRange.vue'
//import FinanceTable from '@/views/pages/FinanceTable.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'
import FinanceReportTab from '@/views/pages/FinanceReport/FinanceReportTab.vue'


export default
{
	extends: FinanceReport,
	components: { 
		FinanceReportTab,
	},

	data() {
      return {
		date: { 
			Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
			End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
		},
		loading: { table:true },
		options: {
			/*
			segment:[
				{ SegmentID: "1", SegmentName: "CONSOLE" }, 
			],
			level:[
				{ Level: "0", LevelName: "GL ACCOUNT" }, 
				{ Level: "1", LevelName: "REKAP" }, 
			],
			*/
			detail1:[
				{ value: "", name: "ALL" }, 
				{ value: "station", name: "BY STATION" }, 
			],
			type:[
				{ value: "", name: "ALL" }, 
				{ value: "SPBU", name: "SPBU" }, 
				{ value: "SPBU-T", name: "SPBU-T" }, 
				{ value: "MODULAR", name: "MODULAR" }, 
				{ value: "PERTASHOP", name: "PERTASHOP" }, 
				{ value: "SHELTER", name: "SHELTER" }, 
				{ value: "SPBG", name: "SPBG" }, 
			],
			status:[
				{ value: "", name: "ALL" }, 
				{ value: "CLEARED", name: "CLEARED" }, 
				{ value: "UNCLEARED", name: "UNCLEARED" }, 
			],
		},
        
		
		tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
		tabList:[
			{label:'Cash Deposit Clearing', name: 'clearingcash', index: '0' },
			{label:'Kliring VA Pangkalan LPG', name: 'clearingedc', index: '1' },
		],

		urlRequestParams: '',
		reportdata: [],
		spbu:{ data:{}, list:[], types:[] },
		dt : this.$route.query.dt ? this.$route.query.dt : Penanggalan().bulanKemarin,
		//segment : this.$route.query.segment ? this.$route.query.segment : "1",
		//level : this.$route.query.level ? this.$route.query.level : "1",
		station: this.$route.query.station ? this.$route.query.station : '',
		detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
		type: this.$route.query.type ? this.$route.query.type : 'SPBU',
		status: this.$route.query.status ? this.$route.query.status : 'UNCLEARED',
		do_reload : 1,
      }
    },
	watch: {	
		
	},      
	mounted() {		

    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

	},

}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>